var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"responsive-page"},[_c('div',{staticClass:"page-wrapper"},[_c('div',{staticClass:"page-and-header"},[_c('router-view')],1),_vm._v(" "),_c('div',{staticClass:"footer-wrapper"},[_c('copyright-footer')],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-70cb3438","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/responsive-pages/ResponsivePage.vue
// module id = null
// module chunks = 